<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年04月24日 14:40:15 +0800
 * @最后修改时间: 2021-12-08 14:20:38
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Roster\RosterFormRecord\components\RosterPlan.vue
 -->
<template>
  <v-container class="fill-height max-width pa-0 ma-0" fluid>
    <v-row dense no-gutters style="height: 32px" class="mb-2">
      <v-col md="12" class="text-center pa-0 align-center d-flex justify-start">
        <v-sheet
          color="transparent"
          class="text-capitalize text-button text--secondary"
        >
          {{
            $t("label_system_date_YMDLabel", {
              year: $getDateTime(startTime, "YYYY"),
              month: $getDateTime(startTime, "MM"),
              day: $getDateTime(startTime, "DD"),
            }) +
            " - " +
            $t("label_system_date_YMDLabel", {
              year: $getDateTime(endTime, "YYYY"),
              month: $getDateTime(endTime, "MM"),
              day: $getDateTime(endTime, "DD"),
            })
          }}</v-sheet
        >
      </v-col>
    </v-row>
    <v-row
      no-gutters
      dense
      style="border-bottom: 1px solid var(--main-border-color); height: 50px"
    >
      <v-col
        v-for="n in cycleType + 1"
        :key="n + 'col'"
        :cols="n === 1 ? 2 : undefined"
        :style="{
          borderRight: n == 1 ? '1px solid var(--main-border-color)' : 'none',
        }"
        class="text-center fill-height pa-0 align-center"
      >
        <v-card
          class="pa-0 fill-height align-end align-items-end"
          :elevation="0"
          tile
        >
          <template v-if="n === 1 && false">
            <DateSelect :startTime="startTime" :endTime="endTime" />
          </template>
          <template v-else>
            <div class="fill-height max-width d-flex justify-end flex-column">
              <DaySelect :time="curPageDate ? curPageDate[n - 2] : null" />
            </div>
          </template>
        </v-card>
      </v-col>
    </v-row>

    <v-container
      class="max-width pa-0 ma-0"
      fluid
      :style="{
        overflow: 'overlay',
        height: $vuetify.breakpoint.height - 460 + 46 + 'px',
      }"
    >
      <noContent v-if="RosterList.length == 0" />

      <v-row
        dense
        no-gutters
        class="max-width flex-wrap"
        v-for="(tr, index) in RosterList"
        :key="index + 'roster'"
        style="height: 100px"
      >
        <v-col
          v-for="n in cycleType + 1"
          :key="n + 'col'"
          :cols="n === 1 ? 2 : undefined"
          :style="{
            borderRight: n == 1 ? '1px solid var(--main-border-color)' : 'none',
          }"
          class="text-center max-width fill-height pa-0 align-center"
        >
          <shiftCard
            :col="n"
            :iSEdited="iSEdited"
            :roster_uuid="Roster_uuid"
            :curType="cycleType"
            :curData="tr"
            :shiftList="shiftList"
            @onShift="toShift"
            :curDate="curPageDate[n - 2]"
          />
        </v-col>
      </v-row>
    </v-container>
    <v-row dense no-gutters justify="start" style="height: 40px">
      <v-col :cols="2" class="text-center fill-height pa-0 align-center">
        <TypeSelect
          :cycletype="cycleType"
          :allDay="allDay"
          @change="
            (type) => {
              cycleType = type;
              page = 1;
            }
          "
        />
      </v-col>
      <v-col :cols="8" class="text-center fill-height pa-0 align-center">
        <v-pagination
          color="grey lighten-2 "
          v-model="page"
          class="text--primary"
          :length="Math.ceil(totalDay / Number(cycleType))"
          :total-visible="10"
        />
      </v-col>
    </v-row>
    <RosterShiftDialog2
      :show="showRosterShift"
      @close="
        showRosterShift = false;
        curData = null;
      "
      @onChange="controlNav"
      :curUuid="Roster_uuid"
      :curData="curData"
      @onSubmit="
        showRosterShift = false;
        nowShow = false;
        curData = null;
        getRosterList();
      "
    />
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import RosterShiftDialog2 from "@/Page/EssAdmin/Roster/RosterFormRecord/components/RosterShiftDialog";
import dayjs from "dayjs";
import DateSelect from "@/Page/EssAdmin/Roster/RosterFormRecord/components/DateSelect";
import DaySelect from "@/Page/EssAdmin/Roster/RosterFormRecord/components/DaySelect";
import TypeSelect from "@/Page/EssAdmin/Roster/RosterFormRecord/components/TypeSelect";
import shiftCard from "@/Page/EssAdmin/Roster/RosterFormRecord/components/shiftCard";

export default {
  name: "RosterPlan",
  components: {
    DateSelect,
    DaySelect,
    TypeSelect,
    shiftCard,
    RosterShiftDialog2,
  },
  props: {
    Roster_uuid: { default: "", type: String },
    startTime: { default: "", type: String },
    endTime: { default: "", type: String },
    shiftList: { default: [], type: Array },
    change: { default: 0, type: Number },
    iSEdited: { default: false, type: Boolean },
  },
  computed: {
    ...mapGetters(["companyLang"]),
    totalDay() {
      if (this.startTime && this.endTime) {
        return dayjs(this.endTime).diff(dayjs(this.startTime), "day") + 1;
      } else {
        return 0;
      }
    },
    allDayByPage() {
      var arr = [];
      const that = this;
      const chunk = this.cycleType;
      for (var i = 0, j = that.allDay.length; i < j; i += chunk) {
        arr.push(that.allDay.slice(i, i + chunk));
      }
      return arr;
    },
    allDay() {
      var arr = [];
      const that = this;
      if (this.startTime && this.endTime) {
        var daylen = dayjs(this.endTime).diff(dayjs(this.startTime), "day"); //总天数
        for (var i = 0; i <= daylen; i++) {
          arr.push(dayjs(that.startTime).add(i, "day").format("YYYY-MM-DD"));
        }
      }
      return arr;
    },
    curPageDate() {
      if (this.page > 0) {
        return this.allDayByPage[this.page - 1];
      } else {
        return this.allDayByPage[0];
      }
    },
  },
  data() {
    return {
      cycleType: 7,
      page: 1,
      nowShow: false,
      RosterList: [],
      showRosterShift: false,
      curData: null,
    };
  },
  watch: {
    change(val) {
      this.getRosterList();
    },
  },
  mounted() {
    // console.log(this.allDayByPage);
    this.getRosterList();
  },
  methods: {
    controlNav: function (f) {
      if (!this.nowShow) {
        this.nowShow = true;
      } else {
        this.nowShow = false;
        this.showRosterShift = false;
        this.curData = null;
      }
    },
    toShift: function (curdata, date) {
      if (!this.iSEdited) return;
      this.curData = curdata;
      this.curData["roster_date"] = date;
      this.showRosterShift = true;
    },
    getRosterList() {
      const that = this;
      if (this.Roster_uuid != "") {
        this.$Request({
          method: "POST",
          table: "ess_att_roster_form_records",
          url: "/roster-record/get-roster-plan/",
          data: {
            roster_form_record_uuid: this.Roster_uuid,
          },
        })
          .then((res) => {
            that.RosterList = res.data;
          })
          .catch((err) => {
            that.RosterList = [];

            that.$showMessage({
              title: that.$t("message_essweb_form_textField_errNoticeTitle"),
              type: "error",
              text: err,
            });
          });
      }
    },
  },
};
</script>
